// import React, { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const ModalPop = ({show, setShow, type, modalData}) => {
    const images = modalData.images !== undefined ? modalData.images : [];
    
    const ImagesHtml = images.map((data,i) => {
        return ( <div className={`carousel-item ${i === 0 && 'active'}`}  key={`img-${i}`}>
                    <img src={`/images/${data}`} className="d-block w-100" alt="..."/>
                </div> )
        }
    )
    return (
        <>
            <Modal show={show} onHide={() => setShow(false)} dialogClassName="custom-modal-projects" size="lg">
                <Modal.Body className="p-0">
                    <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                        </div>
                        <div className="carousel-inner">
                            {ImagesHtml.length === 0 ? <p>Loading</p> : ImagesHtml }
                        </div>
                        <button className="carousel-control carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                        <Button variant="secondary" className="custom-button-modal" onClick={() => setShow(false)}>Close</Button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalPop
